import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Field, NativeSelect, Segmented } from "@/components/common";
import { api, errMsg, todayStr, addDays } from "@/lib/api";

export default function NoteDialog({ open, onOpenChange, onSaved }) {
  const [f, setF] = useState({});
  const [accounts, setAccounts] = useState([]);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!open) return;
    setF({ kind: "check", direction: "received", account_id: "", amount: "", date: todayStr(), due_date: addDays(todayStr(), 30), serial_no: "", bank: "", description: "" });
    api.get("/accounts").then((r) => setAccounts(r.data)).catch(() => {});
  }, [open]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const save = async (e) => {
    e.preventDefault();
    if (!f.account_id) return toast.error("Cari hesap seçin");
    setBusy(true);
    try {
      await api.post("/notes", { ...f, amount: Number(f.amount) });
      toast.success("Çek/senet kaydedildi, cariye işlendi");
      onOpenChange(false);
      onSaved?.();
    } catch (e2) {
      toast.error(errMsg(e2));
    }
    setBusy(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg rounded-[4px]" data-testid="note-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-xl">Çek / Senet Kaydı</DialogTitle>
          <DialogDescription>Alınan evrak cariye tahsilat, verilen evrak ödeme olarak işlenir; vadesine kadar portföyde izlenir.</DialogDescription>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <div className="flex flex-wrap gap-2">
            <Segmented value={f.kind} onChange={(v) => setF({ ...f, kind: v })} prefix="note-kind" options={[["check", "Çek"], ["promissory", "Senet"]]} />
            <Segmented value={f.direction} onChange={(v) => setF({ ...f, direction: v })} prefix="note-direction" options={[["received", "Alınan (Müşteriden)"], ["issued", "Verilen (Tedarikçiye)"]]} />
          </div>
          <Field label="Cari Hesap">
            <NativeSelect value={f.account_id} onChange={set("account_id")} data-testid="note-account-select">
              <option value="">Seçin…</option>
              {accounts.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
            </NativeSelect>
          </Field>
          <div className="grid grid-cols-3 gap-3">
            <Field label="Tutar (₺)" className="col-span-1"><Input required type="number" step="0.01" min="0.01" value={f.amount} onChange={set("amount")} data-testid="note-amount-input" /></Field>
            <Field label="Düzenleme Tarihi"><Input required type="date" value={f.date} onChange={set("date")} data-testid="note-date-input" /></Field>
            <Field label="Vade Tarihi"><Input required type="date" value={f.due_date} onChange={set("due_date")} data-testid="note-due-input" /></Field>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <Field label="Seri / No"><Input value={f.serial_no} onChange={set("serial_no")} data-testid="note-serial-input" /></Field>
            <Field label="Banka"><Input value={f.bank} onChange={set("bank")} data-testid="note-bank-input" /></Field>
          </div>
          <Field label="Açıklama"><Input value={f.description} onChange={set("description")} data-testid="note-description-input" /></Field>
          <DialogFooter>
            <Button type="button" variant="outline" className="rounded-[4px]" onClick={() => onOpenChange(false)} data-testid="note-cancel-button">Vazgeç</Button>
            <Button type="submit" className="rounded-[4px]" disabled={busy} data-testid="note-save-button">{busy ? "Kaydediliyor…" : "Kaydet"}</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
